import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'

import { translate } from 'parking-react-common'

import { forms, routing, ui } from '../redux'

import Panel from '../components/Panel'
import PhoneLoginWithPasswordForm from '../components/PhoneLoginWithPasswordForm'
import SplashFooter from '../components/SplashFooter'

const PhoneLoginWithPasswordContainer = ({ isLoading, t }) => (
    <div>
        <Panel
            title={ t('Login with Password') }
            border={ ui.INTENT.primary }
            isLoading={ isLoading }
        >
            <PhoneLoginWithPasswordForm />
        </Panel>
        <SplashFooter>
            <span>{ t("Don't have a password?") }</span>
            <Link to={ routing.routeFor('login') }>
                { t('Log in using your phone') }
            </Link>
        </SplashFooter>
    </div>
)

PhoneLoginWithPasswordContainer.propTypes = {
    isLoading: PropTypes.bool.isRequired
}

function mapStateToProps(state) {
    return {
        isLoading: forms.isSubmitting(forms.phonePasswordLogin.id)(state)
    }
}

export default translate()(connect(mapStateToProps)(PhoneLoginWithPasswordContainer))
